"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var forms_1 = require("@angular/forms");
var recaptcha_component_1 = require("./recaptcha.component");
var RecaptchaValueAccessorDirective = (function () {
    function RecaptchaValueAccessorDirective(host) {
        this.host = host;
    }
    RecaptchaValueAccessorDirective.prototype.writeValue = function (value) {
        if (!value) {
            this.host.reset();
        }
    };
    RecaptchaValueAccessorDirective.prototype.registerOnChange = function (fn) { this.onChange = fn; };
    RecaptchaValueAccessorDirective.prototype.registerOnTouched = function (fn) { this.onTouched = fn; };
    RecaptchaValueAccessorDirective.prototype.onResolve = function ($event) {
        if (this.onChange) {
            this.onChange($event);
        }
        if (this.onTouched) {
            this.onTouched();
        }
    };
    RecaptchaValueAccessorDirective.decorators = [
        { type: core_1.Directive, args: [{
                    providers: [
                        {
                            multi: true,
                            provide: forms_1.NG_VALUE_ACCESSOR,
                            // tslint:disable-next-line:no-forward-ref
                            useExisting: core_1.forwardRef(function () { return RecaptchaValueAccessorDirective; }),
                        },
                    ],
                    // tslint:disable-next-line:directive-selector
                    selector: 're-captcha[formControlName],re-captcha[formControl],re-captcha[ngModel]',
                },] },
    ];
    /** @nocollapse */
    RecaptchaValueAccessorDirective.ctorParameters = function () { return [
        { type: recaptcha_component_1.RecaptchaComponent, },
    ]; };
    RecaptchaValueAccessorDirective.propDecorators = {
        'onResolve': [{ type: core_1.HostListener, args: ['resolved', ['$event'],] },],
    };
    return RecaptchaValueAccessorDirective;
}());
exports.RecaptchaValueAccessorDirective = RecaptchaValueAccessorDirective;



//////////////////
// WEBPACK FOOTER
// G:/proyectos/website - IntergraMAI/webMai/~/ng-recaptcha/recaptcha/recaptcha-value-accessor.directive.js
// module id = ../../../../ng-recaptcha/recaptcha/recaptcha-value-accessor.directive.js
// module chunks = 3